"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Element = void 0;
/**
 * Abstract class for building blocks of selectors.
 */

var Element = /*#__PURE__*/function () {
  /**
   * Creates new `Element` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param boundRect - The parent bounding box for selection.
   */
  function Element(paper, boundRect) {
    _classCallCheck(this, Element);

    /**
     * The element visibility flag.
     */
    this.isVisible = true;
    this.paper = paper;
    this.boundRect = boundRect;
  }
  /**
   * The `width` of the element.
   */


  _createClass(Element, [{
    key: "hide",

    /**
     * Makes elemement visually hidden.
     */
    value: function hide() {
      this.node.node.setAttribute("visibility", "hidden");
      this.isVisible = false;
    }
    /**
     * Makes element visible.
     */

  }, {
    key: "show",
    value: function show() {
      this.node.node.setAttribute("visibility", "visible");
      this.isVisible = true;
    }
    /**
     * Resizes element to specified `width` and `height`.
     * @param width - New element `width`.
     * @param height - New element `height`.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      this.boundRect.resize(width, height);
    }
  }, {
    key: "width",
    get: function get() {
      return this.boundRect.width;
    }
    /**
     * The `height` of the element.
     */

  }, {
    key: "height",
    get: function get() {
      return this.boundRect.height;
    }
  }]);

  return Element;
}();

exports.Element = Element;